import React from 'react';
import { Hero } from '../components/home/Hero';
import { Problem } from '../components/home/Problem';
import { ThreeSystems } from '../components/home/ThreeSystems';
import { OriginSystem } from '../components/home/OriginSystem';
import { DemoSection } from '../components/home/DemoSection';
import { ResultSection } from '../components/home/ResultSection';
import { Voice } from '../components/home/Voice';
import { Pricing } from '../components/home/Pricing';
import { FinalCTA } from '../components/home/FinalCTA';
export function Home() {
  return <div className="w-full" data-id="element-244" data-mp="24hagxowf1aem">
      <Hero data-id="element-245" data-mp="29g4zcpqh0wy7" />
      <Problem data-id="element-246" data-mp="29flsc42czsyy" />
      <ThreeSystems data-id="element-247" data-mp="29f28ght5euia" />
      <OriginSystem data-id="element-248" data-mp="29ek4ez08vbzt" />
      <DemoSection data-id="element-249" data-mp="29i7z41hfe4g4" />
      <ResultSection data-id="element-250" data-mp="2dhqfql27rtd5" />
      <Voice data-id="element-251" data-mp="2dhyvqltmvesk" />
      <Pricing data-id="element-252" data-mp="2dirxt9hndg4d" />
      <FinalCTA data-id="element-253" data-mp="2dj9z4kj62kj5" />
    </div>;
}